import { Nav2022Context } from "context/Nav2022Context";
import { useProviderInitializedContext } from "./useProviderInitializedContext";

export const useNav2022 = () => {
  return useProviderInitializedContext(Nav2022Context);
};
